import { useDispatch } from 'react-redux';

export function useApiCall() {

    const dispatch = useDispatch()

    const callApi = (sagaAction: string, dataOrParams: any, callbackSuccess: Function, callbackError: Function) => {
        dispatch({
            type: sagaAction,
            payload: dataOrParams,
            callbackSuccess: (data: any) => {
                // Check if data is a blob (for file downloads)
                if (data instanceof Blob) {
                    callbackSuccess && callbackSuccess('', data);
                } else {
                    let message = (data && data.message) || (data.data && data.data.message) || 'Request processed successfully';
                    let resp: any = data ? data : null
                    callbackSuccess && callbackSuccess(message, resp)
                }
            },
            callbackError: (error: any) => {
                // The saga rejects with axios `error.response` when the server replied,
                // or with the raw Error when the request never reached the server.
                // Distinguish so we surface the real backend message (incl. FastAPI `detail`)
                // and do not mis-label HTTP failures as "Network Error".
                const hasHttpResponse = error && typeof error.status === 'number'
                const data = error && error.data ? error.data : null

                let message: string
                if (hasHttpResponse) {
                    const detail = data && (data.detail || data.message || data.error);
                    if (Array.isArray(detail)) {
                        message = detail.map((d: any) => (typeof d === 'object' && d !== null ? (d.reason || d.msg || d.detail || d.message || JSON.stringify(d)) : String(d))).join(', ');
                    } else if (typeof detail === 'object' && detail !== null) {
                        message = detail.reason || detail.msg || detail.message || JSON.stringify(detail);
                    } else {
                        message = detail || error.statusText || `Request failed (${error.status})`;
                    }
                } else {
                    message = (error && error.message) || 'Unable to process the request!'
                }

                callbackError && callbackError(message, data)
            }
        })
    }
    return callApi
}